import { EventSetting } from '../types/eventSetting';

export const getEventSettingInternalId = (eventSetting: EventSetting) => {
  return `${eventSetting.origin}-${eventSetting.notificationType}`;
};
